module.exports = __webpack_public_path__ + "img/solidWaste01.f574d127.png";